import { fetchEventSource } from "@microsoft/fetch-event-source";
import appConfig from "../app-config";

const baseUrl = appConfig.development.apiBaseUrl;

// A 4xx on open (missing route, bad/expired token) will never succeed on
// retry, unlike a dropped connection or a 5xx — so it must stop the loop
// instead of falling into the library's default infinite retry/backoff.
class FatalStreamError extends Error {}

// Native EventSource can't send an Authorization header, so the stream
// needs a fetch-based SSE client to authenticate with the same Bearer token
// used by the rest of the API.
export function openNotificationsStream({ onMessage, onError }) {
  const token = localStorage.getItem("SWAAccessToken");
  if (!token) return () => {};

  const controller = new AbortController();

  fetchEventSource(`${baseUrl}notifications-api/stream`, {
    headers: { Authorization: `Bearer ${token}` },
    signal: controller.signal,
    openWhenHidden: true,
    async onopen(response) {
      if (response.ok) return;
      if (response.status >= 400 && response.status < 500) {
        throw new FatalStreamError(`Notifications stream refused: ${response.status}`);
      }
      throw new Error(`Notifications stream failed to open: ${response.status}`);
    },
    onmessage(ev) {
      if (!ev.data) return;
      try {
        onMessage(JSON.parse(ev.data));
      } catch (e) {
        // ignore malformed/keep-alive payloads
      }
    },
    onerror(err) {
      onError?.(err);
      if (err instanceof FatalStreamError) {
        throw err; // rethrow: tells the library to stop retrying
      }
      // otherwise fall through: let the library's default retry/backoff handle reconnects
    },
  }).catch(() => {});

  return () => controller.abort();
}
